module.exports = __webpack_public_path__ + "assets/98f0d789877feb157f540018f0a95b73.png";